import Vue from 'vue'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

/* eslint-disable */
Vue.component('VSelect', vSelect)
